import dayjs from 'dayjs';
import { TFunction } from 'i18next';
import { DateElement } from '../types/basket-types';

export function setTimeOnDateElement(date: DateElement, time: string | undefined | null): string | undefined | null {
  if (!time) {
    return date.collection?.date;
  }
  const d = dayjs(date.collection?.date);
  const [hours, minutes] = time.split(':').map(Number);
  const timedDate = d.hour(hours).minute(minutes).second(0).millisecond(0);
  return timedDate.toISOString();
}

export function isSameDay(date: DateElement, referenceDate: string | null | undefined) {
  if (!referenceDate) {
    return false;
  }
  return dayjs(date.collection?.date).isSame(dayjs(referenceDate), 'day');
}

function formatRangeTime(time: string | Date) {
  if (time instanceof Date) {
    return dayjs(time).format('ha');
  }

  const [hoursRaw, minutesRaw] = time.split(':');
  const hours = Number(hoursRaw);
  const minutes = Number(minutesRaw ?? '0');

  if (Number.isNaN(hours) || Number.isNaN(minutes)) {
    return dayjs(time).format('ha');
  }

  return dayjs().hour(hours).minute(minutes).second(0).millisecond(0).format('ha');
}

export const formateDate = (
  t: TFunction<[string], undefined>,
  date: Date,
  cutoff?: Date | null,
  range?: { min: string | Date; max: string | Date } | null
) => {
  if (!date) return '';

  const cutoffStr = cutoff ? dayjs(cutoff).format('ddd, Do MMMM HH:mm') : null;
  const rangeStr = range ? `${formatRangeTime(range.min)} - ${formatRangeTime(range.max)}` : null;
  const collectionToday = dayjs(date).isSame(dayjs(), 'day');
  const collectionTomorrow = dayjs(date).isSame(dayjs().add(1, 'day'), 'day');
  const dateLabel = collectionToday ? 'Today' : collectionTomorrow ? 'Tomorrow' : dayjs(date).format('ddd, Do MMMM');

  if (rangeStr) {
    return t(cutoffStr ? 'COLLECTION_DATE_BETWEEN_IF_BOOKED' : 'COLLECTION_DATE_BETWEEN', {
      defaultValue: cutoffStr
        ? '{{date}} between {{range}} if booked before {{cutoff}}.'
        : '{{date}} between {{range}}',
      date: dateLabel,
      range: rangeStr,
      cutoff: cutoffStr
    });
  }

  if (collectionToday) {
    return t(cutoffStr ? 'COLLECTION_DATE_TODAY_IF_BOOKED' : 'COLLECTION_DATE_TODAY', {
      defaultValue: cutoffStr ? '{{date}} if booked before {{cutoff}}' : '{{date}}',
      date: 'Today',
      cutoff: cutoffStr
    });
  }

  if (collectionTomorrow) {
    return t(cutoffStr ? 'COLLECTION_DATE_TOMORROW_IF_BOOKED' : 'COLLECTION_DATE_TOMORROW', {
      defaultValue: cutoffStr ? '{{date}} if booked before {{cutoff}}' : '{{date}}',
      date: 'Tomorrow',
      cutoff: cutoffStr
    });
  }

  return t(cutoffStr ? 'COLLECTION_DATE_IF_BOOKED' : 'COLLECTION_DATE', {
    defaultValue: cutoffStr ? '{{date}} if booked before {{cutoff}}' : '{{date}}',
    date: dayjs(date).format('ddd, Do MMMM'),
    cutoff: cutoffStr
  });
};
